import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Auth.css';
import { API_URL } from '../../config/api';
import { showError, showSuccess } from '../../utils/toast';

const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/brand/tracktcrm-auth-logo.png`;

const MailIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

function ForgotPassword() {
  const [formData, setFormData] = useState({
    email: '',
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email) {
      showError('Email is required');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: formData.email }),
      });

      const data = await response.json();

      if (response.ok) {
        showSuccess(data.message || 'If an account exists, a reset link has been sent to your email.');
      } else {
        showError(data.message || data.error || 'Failed to send reset link');
      }
    } catch (err) {
      showError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form-section">
        <div className="auth-form-container">
          <a className="auth-logo" href="https://tracktcrm.com/" target="_blank" rel="noopener noreferrer" aria-label="TracktCRM">
            <img src={LOGO_SRC} alt="TracktCRM" />
          </a>

          <div className="auth-header">
            <h1>Forgot your TracktCRM password?</h1>
            <p>
              Enter your email address and we&apos;ll send you a link to reset your password.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="email">Email address*</label>
              <div className="input-with-icon">
                <span className="input-leading-icon"><MailIcon /></span>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  required
                />
              </div>
            </div>

            <button type="submit" className="auth-button" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>

          <Link to="/login" className="auth-back-link">
            ← Back to Login
          </Link>

          <div className="auth-footer">
            <p>
              Don&apos;t have an account?{' '}
              <button
                type="button"
                className="resend-button"
                onClick={() => navigate('/register')}
              >
                Register
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
